import client from '../client';
import endpoints from '../endpoints';

/**
 * 결제 — 서비스 + 관리자 API
 * API_DOCS: 4. 결제 / 29. 관리자 - 거래/매출
 */

/* ── 서비스 (유저용) ── */

export const preparePayment = async (data) => {
  const res = await client.post(endpoints.payments.prepare, data);
  return res.data;
};

export const confirmPayment = async (data) => {
  const res = await client.post(endpoints.payments.confirm, data);
  return res.data;
};

export const getCards = async () => {
  const res = await client.get(endpoints.payments.cards);
  return res.data;
};

export const registerCard = async (data) => {
  const res = await client.post(endpoints.payments.cards, data);
  return res.data;
};

export const deleteCard = async (cardId) => {
  const res = await client.delete(endpoints.payments.cardDelete(cardId));
  return res.data;
};

export const getPaymentById = async (id) => {
  const res = await client.get(endpoints.payments.detail(id));
  return res.data;
};

export const refundPayment = async (id, data = {}) => {
  const res = await client.post(endpoints.payments.refund(id), data);
  return res.data;
};

export const getReceipt = async (id) => {
  const res = await client.get(endpoints.payments.receipt(id));
  return res.data;
};

export const sendReceiptEmail = async (id, email) => {
  const res = await client.post(endpoints.payments.receiptEmail(id), { email });
  return res.data;
};

/* ── 관리자 ── */

export const getAdminTransactions = async (params = {}) => {
  const res = await client.get(endpoints.admin.transactions.list, { params });
  return res.data;
};

export const getAdminTransactionSummary = async (params = {}) => {
  const res = await client.get(endpoints.admin.transactions.summary, { params });
  return res.data;
};

export const exportAdminTransactions = async (params = {}) => {
  const res = await client.get(endpoints.admin.transactions.export, { params, responseType: 'blob' });
  return res.data;
};

export const getAdminTransactionById = async (id) => {
  const res = await client.get(endpoints.admin.transactions.detail(id));
  return res.data;
};

/** POST /api/admin/payments/:id/refund — 관리자 환불 처리 */
export const adminRefund = async (id, data = {}) => {
  const res = await client.post(`/api/admin/payments/${id}/refund`, data);
  return res.data;
};
